import KarteInterface from "../../../../interfaces/KarteInterface";
import KarteComment from "../KarteComment/index";
import KarteCommentForm from "../KarteCommentForm/index";
import styles from "./styles.scss";

interface Props {
  karte: KarteInterface;
  studentId: string;
  sectionId: string;
}

const renderComments = (props: Props) => {
  const { karte, sectionId, studentId } = props;

  return karte.comments.map((comment) => (
    <KarteComment
      key={`KarteItemFooter-comment-${comment.id}`}
      karte={karte}
      comment={comment}
      studentId={studentId}
      sectionId={sectionId}
    />
  ));
};

const KarteItemFooter = (props: Props) => {
  return (
    <div className={styles.root}>
      <div className={styles.main}>
        {renderComments(props)}
        <KarteCommentForm
          karte={props.karte}
          studentId={props.studentId}
          sectionId={props.sectionId}
        />
      </div>
    </div>
  );
};

export default KarteItemFooter;
